module.exports = __webpack_public_path__ + "static/media/wrong-network.ec9ccdda.svg";